var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bullet-cont d-inline-flex align-items-center"},[_c('span',{staticClass:"count rounded-circle",class:_vm.bulletLabelColor},[_vm._v(" "+_vm._s(_vm.bulletLabelValue)+" ")]),_c('span',{staticClass:"count-label"},[_vm._v(_vm._s(_vm.bulletLabelName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }